module.exports = __webpack_public_path__ + "img/defense_recovered_right.a59ac28c.jpg";